(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[760],{

/***/ 1646:
/***/ (function(module) {

!function(t,s){ true?module.exports=s():0}(this,(function(){"use strict";var t,s,n=1e3,i=6e4,e=36e5,r=864e5,o=31536e6,u=2628e6,d=/^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/,a=/\[([^\]]+)]|YYYY|YY|Y|M{1,2}|D{1,2}|H{1,2}|m{1,2}|s{1,2}|SSS/g,h={years:o,months:u,days:r,hours:e,minutes:i,seconds:n,milliseconds:1,weeks:6048e5},c=function(t){return t instanceof g},f=function(t,s,n){return new g(t,n,s.$l)},m=function(t){return s.p(t)+"s"},l=function(t){return t<0},$=function(t){return l(t)?Math.ceil(t):Math.floor(t)},y=function(t){return Math.abs(t)},v=function(t,s){return t?l(t)?{negative:!0,format:""+y(t)+s}:{negative:!1,format:""+t+s}:{negative:!1,format:""}},g=function(){function l(t,s,n){var i=this;if(this.$d={},this.$l=n,void 0===t&&(this.$ms=0,this.parseFromMilliseconds()),s)return f(t*h[m(s)],this);if("number"==typeof t)return this.$ms=t,this.parseFromMilliseconds(),this;if("object"==typeof t)return Object.keys(t).forEach((function(s){i.$d[m(s)]=t[s]})),this.calMilliseconds(),this;if("string"==typeof t){var e=t.match(d);if(e){var r=e.slice(2).map((function(t){return null!=t?Number(t):0}));return this.$d.years=r[0],this.$d.months=r[1],this.$d.weeks=r[2],this.$d.days=r[3],this.$d.hours=r[4],this.$d.minutes=r[5],this.$d.seconds=r[6],this.calMilliseconds(),this}}return this}var y=l.prototype;return y.calMilliseconds=function(){var t=this;this.$ms=Object.keys(this.$d).reduce((function(s,n){return s+(t.$d[n]||0)*h[n]}),0)},y.parseFromMilliseconds=function(){var t=this.$ms;this.$d.years=$(t/o),t%=o,this.$d.months=$(t/u),t%=u,this.$d.days=$(t/r),t%=r,this.$d.hours=$(t/e),t%=e,this.$d.minutes=$(t/i),t%=i,this.$d.seconds=$(t/n),t%=n,this.$d.milliseconds=t},y.toISOString=function(){var t=v(this.$d.years,"Y"),s=v(this.$d.months,"M"),n=+this.$d.days||0;this.$d.weeks&&(n+=7*this.$d.weeks);var i=v(n,"D"),e=v(this.$d.hours,"H"),r=v(this.$d.minutes,"M"),o=this.$d.seconds||0;this.$d.milliseconds&&(o+=this.$d.milliseconds/1e3,o=Math.round(1e3*o)/1e3);var u=v(o,"S"),d=t.negative||s.negative||i.negative||e.negative||r.negative||u.negative,a=e.format||r.format||u.format?"T":"",h=(d?"-":"")+"P"+t.format+s.format+i.format+a+e.format+r.format+u.format;return"P"===h||"-P"===h?"P0D":h},y.toJSON=function(){return this.toISOString()},y.format=function(t){var n=t||"YYYY-MM-DDTHH:mm:ss",i={Y:this.$d.years,YY:s.s(this.$d.years,2,"0"),YYYY:s.s(this.$d.years,4,"0"),M:this.$d.months,MM:s.s(this.$d.months,2,"0"),D:this.$d.days,DD:s.s(this.$d.days,2,"0"),H:this.$d.hours,HH:s.s(this.$d.hours,2,"0"),m:this.$d.minutes,mm:s.s(this.$d.minutes,2,"0"),s:this.$d.seconds,ss:s.s(this.$d.seconds,2,"0"),SSS:s.s(this.$d.milliseconds,3,"0")};return n.replace(a,(function(t,s){return s||String(i[t])}))},y.as=function(t){return this.$ms/h[m(t)]},y.get=function(t){var s=this.$ms,n=m(t);return"milliseconds"===n?s%=1e3:s="weeks"===n?$(s/h[n]):this.$d[n],s||0},y.add=function(t,s,n){var i;return i=s?t*h[m(s)]:c(t)?t.$ms:f(t,this).$ms,f(this.$ms+i*(n?-1:1),this)},y.subtract=function(t,s){return this.add(t,s,!0)},y.locale=function(t){var s=this.clone();return s.$l=t,s},y.clone=function(){return f(this.$ms,this)},y.humanize=function(s){return t().add(this.$ms,"ms").locale(this.$l).fromNow(!s)},y.valueOf=function(){return this.asMilliseconds()},y.milliseconds=function(){return this.get("milliseconds")},y.asMilliseconds=function(){return this.as("milliseconds")},y.seconds=function(){return this.get("seconds")},y.asSeconds=function(){return this.as("seconds")},y.minutes=function(){return this.get("minutes")},y.asMinutes=function(){return this.as("minutes")},y.hours=function(){return this.get("hours")},y.asHours=function(){return this.as("hours")},y.days=function(){return this.get("days")},y.asDays=function(){return this.as("days")},y.weeks=function(){return this.get("weeks")},y.asWeeks=function(){return this.as("weeks")},y.months=function(){return this.get("months")},y.asMonths=function(){return this.as("months")},y.years=function(){return this.get("years")},y.asYears=function(){return this.as("years")},l}(),p=function(t,s,n){return t.add(s.years()*n,"y").add(s.months()*n,"M").add(s.days()*n,"d").add(s.hours()*n,"h").add(s.minutes()*n,"m").add(s.seconds()*n,"s").add(s.milliseconds()*n,"ms")};return function(n,i,e){t=e,s=e().$utils(),e.duration=function(t,s){var n=e.locale();return f(t,{$l:n},s)},e.isDuration=c;var r=i.prototype.add,o=i.prototype.subtract;i.prototype.add=function(t,s){return c(t)?p(this,t,1):r.bind(this)(t,s)},i.prototype.subtract=function(t,s){return c(t)?p(this,t,-1):o.bind(this)(t,s)}}}));

/***/ }),

/***/ 63070:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/calls",
      function () {
        return __webpack_require__(64550);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74249);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__);




const ContentLoading = (param)=>{
    let { label , fullScreen =false , className =""  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const text = label || t("Loading...");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        role: "status",
        "aria-live": "polite",
        "aria-label": text,
        className: "".concat((_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRoot), " ").concat(fullScreen ? (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRootFullScreen) : "", " ").concat(className).trim(),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: "/images/loading/spinner.svg",
                alt: "",
                width: 64,
                height: 64,
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingSpinner),
                "aria-hidden": "true",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingLabel),
                children: text
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentLoading);


/***/ }),

/***/ 76039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ useAndroidDevicePagedData; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_api_dashboard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95629);
/* harmony import */ var src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82017);
/* harmony import */ var src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26771);




/** INSTALLED_APP 按包名去重，兼容 bundleid / bundleId */ function getAppBundleId(item) {
    return (item === null || item === void 0 ? void 0 : item.bundleid) || (item === null || item === void 0 ? void 0 : item.bundleId) || "";
}
function dedupeInstalledApps(items) {
    const seen = new Set();
    const result = [];
    for (const item of items){
        const key = getAppBundleId(item);
        if (key) {
            if (seen.has(key)) continue;
            seen.add(key);
        }
        result.push(item);
    }
    return result;
}
/**
 * Android Cloud / Local 分页列表 Hook，设备切换时重置分页并取消旧请求。
 *
 * @param {Object} options
 * @param {'local'|'cloud'} options.source - 数据源：Local 或 Gcloud
 * @param {string} options.category - 接口 category 参数
 * @param {number} options.limit - 每页条数
 * @returns {{ context: Object|null, data: Array, loading: boolean, total: number, loadNext: Function, reload: Function, setDateRange: Function }}
 */ function useAndroidDevicePagedData(param) {
    let { source , category , limit  } = param;
    const [data, setData] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
    const [total, setTotal] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
    const [context, setContext] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const scopeRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const revisionRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    const pageRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        offset: 0,
        maxNum: false,
        loading: false
    });
    /** @type {React.MutableRefObject<{ startTime: number, endTime: number } | null>} 日期筛选区间（毫秒） */ const dateRangeRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const loadPage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async function(offset) {
        let scope = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : scopeRef.current, revision = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : revisionRef.current;
        if (!scope || pageRef.current.loading || pageRef.current.maxNum) return;
        pageRef.current.loading = true;
        const { context: scopedContext , signal , isCurrent  } = scope;
        const request = source === "local" ? src_api_dashboard__WEBPACK_IMPORTED_MODULE_1__/* .getLocalAndroidAll */ .gH : src_api_dashboard__WEBPACK_IMPORTED_MODULE_1__/* .getGcloudAll */ .U1;
        const params = {
            category,
            offset,
            limit
        };
        if (source === "local") params.deviceUdid = (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_3__/* .readLocalDeviceUdid */ .S)(scopedContext);
        if (source === "cloud" && (scopedContext === null || scopedContext === void 0 ? void 0 : scopedContext.physicalDeviceKey)) {
            params.deviceUdid = scopedContext.physicalDeviceKey;
        }
        // 日期筛选走接口：不筛选时不传，请求与改动前一致
        const range = dateRangeRef.current;
        if (range) {
            if (range.startTime != null) params.startTime = range.startTime;
            if (range.endTime != null) params.endTime = range.endTime;
        }
        try {
            var ref;
            const response = await request({
                username: source === "local" ? (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_3__/* .readUserEmail */ .t)() : (scopedContext === null || scopedContext === void 0 ? void 0 : scopedContext.username) || "",
                params
            }, {
                signal
            });
            if (!isCurrent() || revision !== revisionRef.current) return;
            const contents = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.contents;
            if (contents) {
                setData((old)=>{
                    const merged = offset === 0 ? [
                        ...contents
                    ] : [
                        ...old,
                        ...contents
                    ];
                    return category === "INSTALLED_APP" ? dedupeInstalledApps(merged) : merged;
                });
                setTotal(response.data.totalCount || 0);
                pageRef.current.offset = offset;
                if (contents.length < limit) pageRef.current.maxNum = true;
            } else {
                pageRef.current.maxNum = true;
            }
            setLoading(false);
        } catch (error) {
            if (isCurrent() && revision === revisionRef.current && (error === null || error === void 0 ? void 0 : error.code) !== "ERR_CANCELED") {
                ;
                setLoading(false);
            }
        } finally{
            if (isCurrent() && revision === revisionRef.current) pageRef.current.loading = false;
        }
    }, [
        category,
        limit,
        source
    ]);
    // 设备切换：重置分页 state 并从第一页重新请求
    (0,src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_2__/* .useDeviceScopedInit */ .A)((0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((_, scope)=>{
        scopeRef.current = scope;
        revisionRef.current += 1;
        dateRangeRef.current = null;
        pageRef.current = {
            offset: 0,
            maxNum: false,
            loading: false
        };
        setData([]);
        setLoading(true);
        setTotal(0);
        setContext(scope.context);
        loadPage(0, scope, revisionRef.current);
    }, [
        loadPage
    ]));
    const loadNext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        const page = pageRef.current;
        if (!page.maxNum && !page.loading) loadPage(page.offset + limit);
    }, [
        limit,
        loadPage
    ]);
    const reload = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        const scope = scopeRef.current;
        if (!scope) return;
        revisionRef.current += 1;
        pageRef.current = {
            offset: 0,
            maxNum: false,
            loading: false
        };
        setData([]);
        setLoading(true);
        setTotal(0);
        loadPage(0, scope, revisionRef.current);
    }, [
        loadPage
    ]);
    /**
   * 设置日期筛选区间并重新从第一页拉取（区间由接口过滤，不是本地过滤）。
   * @param {{ startTime: number, endTime: number } | null} range - 毫秒时间戳；null 表示清除筛选
   */ const setDateRange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((range)=>{
        dateRangeRef.current = range;
        reload();
    }, [
        reload
    ]);
    return {
        context,
        data,
        loading,
        total,
        loadNext,
        reload,
        setDateRange
    };
}


/***/ }),

/***/ 82017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useDeviceScopedInit; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34745);



/**

 * 当前选中设备变化时重新执行初始化逻辑（拉数、重置本地 state 等）。

 * 通过 requestKey 与 AbortSignal 丢弃切换前未完成的异步请求。

 *

 * @param {(deviceUser: string, scope: {

 *   context: Object,

 *   signal: AbortSignal,

 *   isCurrent: () => boolean

 * }) => void} initFn - 设备作用域初始化回调，需 useCallback 包裹

 */ function useDeviceScopedInit(initFn) {
    const deviceUser = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((state)=>state.Common.deviceUser);
    const context = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceContext */ .VQ);
    const requestKey = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceRequestKey */ .rx);
    const contextRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(context);
    contextRef.current = context;
    const effectiveDeviceUser = deviceUser || (context === null || context === void 0 ? void 0 : context.accountId) || (context === null || context === void 0 ? void 0 : context.username);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!effectiveDeviceUser) return;
        const controller = new AbortController();
        let active = true;
        const scopedContext = contextRef.current;
        // 仅当 requestKey 仍与当前 Redux 一致时，才应用异步结果
        const isCurrent = ()=>{
            var ref;
            return active && !controller.signal.aborted && ((ref = contextRef.current) === null || ref === void 0 ? void 0 : ref.requestKey) === requestKey;
        };
        initFn(effectiveDeviceUser, {
            context: scopedContext,
            signal: controller.signal,
            isCurrent
        });
        return ()=>{
            active = false;
            controller.abort();
        };
    }, [
        effectiveDeviceUser,
        initFn,
        requestKey
    ]);
}


/***/ }),

/***/ 64550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61906);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(90948);
/* harmony import */ var src_hooks_useAndroidDevicePagedData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76039);
/* harmony import */ var src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31909);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1646);
/* harmony import */ var dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9473);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34745);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(15378);
/* harmony import */ var src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(74743);
// ** React Imports

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-picker-input {\n    width: auto;\n  }\n  .ant-picker-input > input {\n    max-width: 98px;\n    text-align: center;\n    text-overflow: clip !important;  /* 禁止使用省略号 */\n    overflow: visible !important;    /* 允许文本溢出 */\n  }\n  .ant-picker-input > input::placeholder {\n    color:#ADADAD;\n  }\n  .ant-picker-suffix {\n    order:-1;\n    opacity:1 !important;\n    margin-right:11px;\n  }\n  .ant-picker-clear {\n    display: block !important;\n    opacity:1 !important;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}




// request








dayjs__WEBPACK_IMPORTED_MODULE_6___default().extend((dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_7___default()));


const { RangePicker  } = antd__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z;
const CustomRangePicker = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(RangePicker)(_templateObject());
const ScrollDiv = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)("div")({
    "@media (max-width: 600px)": {
        "-msOverflowStyle": "none",
        /* 适用于 IE 和 Edge */ scrollbarWidth: "none",
        /* 适用于 Firefox */ "&::-webkit-scrollbar": {
            display: "none"
        }
    }
});
const Calls = ()=>{
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common");
    let Advanced = window.localStorage.getItem("Advanced");
    Advanced = Advanced == null || Advanced == 0 ? true : false;
    // ** State
    const [initCalls, setInitCalls] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const [addUserOpen, setAddUserOpen] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [allCalls, setAllCalls] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const [calls, setCalls] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const [active, setActive] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("CALL_HISTORY");
    const [currentState, setCurrentState] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("all");
    const [antdSelectedDates, setAntdSelectedDates] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const { context , data: callRecords , loading: isLoading , loadNext , setDateRange  } = (0,src_hooks_useAndroidDevicePagedData__WEBPACK_IMPORTED_MODULE_4__/* .useAndroidDevicePagedData */ .v)({
        source: "local",
        category: active,
        limit: 50
    });
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const result = callRecords.map((item)=>{
            return {
                ...item,
                time: active == "VOICEMAIL" ? dayjs__WEBPACK_IMPORTED_MODULE_6___default()(Number("".concat(item.date, "000"))).format("YYYY-MM-DD HH:mm") : dayjs__WEBPACK_IMPORTED_MODULE_6___default()(Number("".concat(item.date))).format("YYYY-MM-DD HH:mm"),
                url: "https://cos.spyx.com/".concat(item.url, ".mp3"),
                type: active,
                playing: false,
                sender: active == "VOICEMAIL" ? item.sender : item.displayName
            };
        });
        setAllCalls(result);
        setInitCalls(result);
    }, [
        active,
        callRecords
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        setCurrentState("all");
        setAntdSelectedDates([]);
        setAddUserOpen(false);
        setScroll(0);
    }, [
        context === null || context === void 0 ? void 0 : context.requestKey
    ]);
    // 获取当前状态的数据
    const getStateData = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        let datas = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : antdSelectedDates;
        const _list = [
            ...allCalls
        ];
        let list = _list.filter((item)=>{
            if (currentState === "all") {
                return item;
            } else if (currentState === "outgoing") {
                return item.originated === 1;
            } else if (currentState === "missed") {
                return item.originated === 0 && item.duration === 0;
            } else if (currentState === "incoming") {
                return item.originated === 0 && item.duration !== 0;
            } else {
                return item;
            }
        });
        if (datas && datas.length === 2) {
            const { startTime , endTime  } = (0,src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_5__/* .buildTimeParams */ .W2)(datas);
            const newDateList = list.filter((item)=>{
                var _created;
                // item.date 可能是秒或毫秒，统一成毫秒再比较
                const itemTime = (0,src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_5__/* .toMillis */ .eq)((_created = item.created) !== null && _created !== void 0 ? _created : item.date);
                return itemTime >= startTime && itemTime <= endTime;
            });
            list = newDateList;
        }
        setCalls(()=>[
                ...list
            ]);
    }, [
        allCalls,
        antdSelectedDates,
        currentState
    ]);
    // 查看不同状态的通话记录
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        getStateData();
    }, [
        getStateData
    ]);
    const domRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    // 滚动百分比
    const [scroll, setScroll] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0);
    // 监听进度条滚动
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const handleScroll = ()=>{
            if (domRef.current) {
                const { scrollTop , scrollHeight , clientHeight  } = domRef.current;
                const progress = scrollTop / (scrollHeight - clientHeight) * 100;
                setScroll(progress.toFixed(0));
            }
        };
        const currentRef = domRef.current;
        if (currentRef) {
            currentRef.addEventListener("scroll", handleScroll);
        }
        return ()=>{
            if (currentRef) {
                currentRef.removeEventListener("scroll", handleScroll);
            }
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (scroll >= 100) loadNext();
    }, [
        loadNext,
        scroll
    ]);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_8__/* .useDispatch */ .I0)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const title = t("Call");
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_11__/* .setCurrentTab */ .Lw)(title));
        return ()=>dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_11__/* .setCurrentTab */ .Lw)(""));
    }, [
        dispatch,
        t
    ]);
    // 获取今天的日期
    const today = dayjs__WEBPACK_IMPORTED_MODULE_6___default()().format("YYYY-MM-DD");
    // 获取七天前的日期
    const sevenDaysAgo = dayjs__WEBPACK_IMPORTED_MODULE_6___default()().subtract(7, "day").format("YYYY-MM-DD");
    //选择日期范围
    const handleDateChange = (dates)=>{
        const picked = dates && dates.length === 2 ? dates : [];
        setAntdSelectedDates(picked);
        // 走接口按日期重新拉取（不筛选时传 null）；getStateData 作为本地兜底
        const { startTime , endTime  } = (0,src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_5__/* .buildTimeParams */ .W2)(picked);
        setDateRange(picked.length === 2 ? {
            startTime,
            endTime
        } : null);
        getStateData(picked);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_10___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                    name: "format-detection",
                    content: "telephone=no"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "w-[144px] Blds:w-[528px] h-[33px] Blds:h-[42px] flex bg-[#EAEAEA] Blds:bg-inherit rounded-[8px] mb-[15px] mx-auto",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "flex-1 Blds:flex-auto flex justify-center items-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "".concat(currentState === "all" ? "bg-[#FFF] Blds:bg-[#EAEAEA] drop-shadow-[0_2px_2px_rgba(0,0,0,0.1)] Blds:drop-shadow-none" : "", " w-[30px] Blds:w-auto h-[30px] Blds:h-auto Blds:px-[4px] Blds:py-[9px] flex justify-center items-center rounded-[8px] cursor-pointer"),
                            onClick: ()=>setCurrentState("all"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_9___default()), {
                                    src: "/images/calls/all-call.svg",
                                    width: 24,
                                    height: 24,
                                    alt: "all call"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                    className: "text-[14px] text-[#000] ml-[8px] Bld:hidden",
                                    children: t("All Calls")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "flex-1 Blds:flex-auto flex justify-center items-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "".concat(currentState === "missed" ? "bg-[#FFF] Blds:bg-[#EAEAEA] drop-shadow-[0_2px_2px_rgba(0,0,0,0.1)] Blds:drop-shadow-none" : "", " w-[30px] Blds:w-auto h-[30px] Blds:h-auto Blds:px-[4px] Blds:py-[9px] flex justify-center items-center rounded-[8px] cursor-pointer"),
                            onClick: ()=>setCurrentState("missed"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_9___default()), {
                                    src: "/images/calls/missed.svg",
                                    width: 24,
                                    height: 24,
                                    alt: "missed"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                    className: "text-[14px] text-[#000] ml-[8px] Bld:hidden",
                                    children: t("Missed Calls")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "flex-1 Blds:flex-auto flex justify-center items-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "".concat(currentState === "outgoing" ? "bg-[#FFF] Blds:bg-[#EAEAEA] drop-shadow-[0_2px_2px_rgba(0,0,0,0.1)] Blds:drop-shadow-none" : "", " w-[30px] Blds:w-auto h-[30px] Blds:h-auto Blds:px-[4px] Blds:py-[9px] flex justify-center items-center rounded-[8px] cursor-pointer"),
                            onClick: ()=>setCurrentState("outgoing"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_9___default()), {
                                    src: "/images/calls/outgoing.svg",
                                    width: 24,
                                    height: 24,
                                    alt: "outgoing"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                    className: "text-[14px] text-[#000] ml-[8px] Bld:hidden",
                                    children: t("Incoming Calls")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "flex-1 Blds:flex-auto flex justify-center items-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "".concat(currentState === "incoming" ? "bg-[#FFF] Blds:bg-[#EAEAEA] drop-shadow-[0_2px_2px_rgba(0,0,0,0.1)] Blds:drop-shadow-none" : "", " w-[30px] Blds:w-auto h-[30px] Blds:h-auto Blds:px-[4px] Blds:py-[9px] flex justify-center items-center rounded-[8px] cursor-pointer"),
                            onClick: ()=>setCurrentState("incoming"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_9___default()), {
                                    src: "/images/calls/incoming.svg",
                                    width: 24,
                                    height: 24,
                                    alt: "incoming"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                    className: "text-[14px] text-[#000] ml-[8px] Bld:hidden",
                                    children: t("Outgoing Calls")
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ScrollDiv, {
                ref: domRef,
                className: "bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] Bxl:h-[calc(var(--vh2)*100-144px)] Bxls:Headers5:h-[calc(var(--vh2)*100-202px)] Header5:big:h-[calc(var(--vh2)*100-267px)] bigs:h-[calc(var(--vh2)*100-327px)] pb-[20px] flex flex-col overflow-auto relative",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("table", {
                        className: "border-separate border-spacing-x-[15px] border-spacing-y-[10px] w-full table-fixed px-5 smj:hidden",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("tr", {
                                className: "sticky top-0 bg-[#FFF] relative",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                        className: "text-nowrap pt-[10px] text-start text-[14px] text-[#000] font-[600]",
                                        children: t("NAME OR NUMBER")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                        className: "text-nowrap pt-[10px] text-start text-[14px] text-[#000] font-[600]",
                                        children: t("STATE")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                        className: "text-nowrap pt-[10px] text-start text-[14px] text-[#000] font-[600]",
                                        children: t("NAME")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                        className: "text-nowrap pt-[10px] text-start text-[14px] text-[#000] font-[600]",
                                        children: t("DURATION")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                        className: "text-nowrap pt-[10px] text-start text-[14px] text-[#000] font-[600]",
                                        children: t("DATE")
                                    })
                                ]
                            }),
                            calls.map((row, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                            className: "text-[14px] text-[#000] text-nowrap",
                                            children: row.displayName || row.phoneNumber
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("td", {
                                            className: "text-[14px] text-[#000] text-nowrap flex items-center pr-[30px]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_9___default()), {
                                                    className: "mr-[5px]",
                                                    src: row.originated === 0 ? row.duration === 0 ? "/images/calls/missed.svg" : "/images/calls/incoming.svg" : "/images/calls/outgoing.svg",
                                                    width: 24,
                                                    height: 24,
                                                    alt: row.originated === 0 ? row.duration === 0 ? "missed" : "incoming" : "outgoing"
                                                }),
                                                row.originated === 0 ? row.duration === 0 ? "Missed" : "Incoming" : "Outgoing"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                            className: "text-[14px] text-[#000] text-nowrap",
                                            children: row.name
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                            className: "text-[14px] text-[#000] text-nowrap",
                                            children: dayjs__WEBPACK_IMPORTED_MODULE_6___default().duration(row.duration, "seconds").format("mm:ss")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                            className: "text-[14px] text-[#000] text-nowrap",
                                            children: row.time
                                        })
                                    ]
                                }, i))
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "smjs:hidden h-auto",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "w-full p-[15px_15px_12px] sticky top-0 bg-white border-[#e6e6e6] border-b-[0.5px] relative",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomRangePicker, {
                                    format: "YYYY-MM-DD" // 左右两边显示的日期格式
                                    ,
                                    placeholder: [
                                        sevenDaysAgo,
                                        today
                                    ],
                                    separator: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        className: "text-[#ADADAD]",
                                        children: "~"
                                    }),
                                    suffixIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_9___default()), {
                                        src: "/images/calls/calendar.svg",
                                        alt: "calendar",
                                        width: 18,
                                        height: 18
                                    }),
                                    className: "w-full h-[40px] bg-[#F8F8F8]",
                                    inputReadOnly: true,
                                    // allowClear={false} // 清除按钮是否显示
                                    onChange: handleDateChange
                                })
                            }),
                            calls.map((row, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "h-[64px] flex w-full",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "w-[20px] mt-3 mr-2 ml-[15px]",
                                            children: row.originated === 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_9___default()), {
                                                src: "/images/calls/outgoing2.svg",
                                                alt: "outgoing",
                                                width: 18,
                                                height: 18
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "border-[#e6e6e6] border-b-[0.5px] w-full flex flex-col justify-center h-[64px] font-[Poppins]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: "flex justify-between",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                            className: "text-[16px] font-[500] leading-[24px] ".concat(row.originated === 0 && row.duration === 0 ? " text-[#FE1616]" : " text-[#000000]"),
                                                            children: row.displayName || row.phoneNumber
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                            className: "text-[16px] font-[500] leading-[24px] text-[#000000] mr-[15px]",
                                                            children: row.name
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: "flex justify-between",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                            className: "text-[14px] font-[400] leading-[21px] text-[#8A8A8E]",
                                                            children: dayjs__WEBPACK_IMPORTED_MODULE_6___default().duration(row.duration, "seconds").format("HH:mm:ss")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                            className: "text-[14px] font-[400] text-[#8A8A8E] leading-[21px] mr-[15px]",
                                                            children: dayjs__WEBPACK_IMPORTED_MODULE_6___default()(row.time).format("YYYY/MM/DD HH:mm")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, index))
                        ]
                    }),
                    isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "absolute inset-0 z-[20] bg-[#FFF] rounded-[10px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {})
                    }) : null,
                    allCalls.length > 0 || isLoading || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "text-center px-2 absolute inset-0 flex justify-center items-center pointer-events-none",
                        children: [
                            t("It appears theres no data to show here yet"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                            t("If data exists it may take up to 1 hour to download and appear"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                            t("We suggest checking back in a little while")
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Calls);


/***/ }),

/***/ 74249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentLoadingRoot":"ContentLoading_contentLoadingRoot__ypzGH","contentLoadingRootFullScreen":"ContentLoading_contentLoadingRootFullScreen__ZmB8e","contentLoadingSpinner":"ContentLoading_contentLoadingSpinner__4vCxU","content-loading-spin":"ContentLoading_content-loading-spin__K0YUP","contentLoadingLabel":"ContentLoading_contentLoadingLabel__S0w79"};

/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,5432,9830,5170,1033,8914,3368,1675,5378,9774,2888,179], function() { return __webpack_exec__(63070); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);